const default_tabs = [
  { name: 'general' },
  { name: 'password' },
  { name: 'info'},
  { name: 'payment', title: 'router.userProfilePayment' },
  { name: 'social' },
  { name: 'token' },
  { name: 'notification' },
  { name: 'history' },
  { name: 'advertisement' },
];

export function checkTabPathTitle(to, tabs = default_tabs) {
  const tab = tabs.find(t => t.name === to.params.tab);
      to.meta.i18n = tab.title ?? 'router.userProfile';
  }



// WEBPACK FOOTER //
// ./src/core/helpers/routeHelpers.js